import { render } from "./showExchangeProcess.vue?vue&type=template&id=f60c18b0&lang=pug"
import script from "./showExchangeProcess.vue?vue&type=script&setup=true&lang=js"
export * from "./showExchangeProcess.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__